// "INSTRUCTIONS FOR SAM (KYCK ONLY)": the GoHighLevel "master prompt" equivalent. PURE.
//
// Scott's requirement: when the bot gets stuck on something, Kyck fixes it in the UI, without code.
// This is the knob. It changes HOW Sam talks and behaves. It cannot change WHAT Sam may claim and
// it cannot loosen any rule that lives in code.
//
// ⚠️⚠️ TRUST POSITION. These words go into the prompt as INSTRUCTIONS, outside the untrusted
// business-information fence. That is the whole difference from the profile, and it is only safe
// because the CLIENT cannot write it: never host this field in the client portal.
//
// ⚠️⚠️ NOT A FACT SOURCE. The price verifier's allowed-figure corpus is built from the profile and
// live promotions only; it never reads these instructions (priceVerifier.ts takes no such input
// and a test pins it). So "offer 50% off" or "memberships are $19.95" written here is still HELD.
// This stops the GoHighLevel habit of pasting prices into the prompt from becoming a second,
// drifting price list.

import { botNameOf } from '../botName.js';

export const INSTRUCTIONS_MAX = 6000;

/** The field label, with THIS bot's name ("Instructions for Mia (Kyck only)"); an empty name reads "the assistant". */
export const instructionsLabel = (assistantName: string | null | undefined): string => `Instructions for ${botNameOf(assistantName)} (Kyck only)`;

export const instructionsHint = (assistantName: string | null | undefined): string =>
  `How ${botNameOf(assistantName)} should behave. Prices, hours and offers go in the Business Profile. Figures written here are not trusted and will be held.`;

/** The heading the prompt carries over this text. The RULES above always win. */
export const INSTRUCTIONS_PROMPT_HEADING =
  'KYCK OPERATOR GUIDANCE: how to behave for this club. Follow it, except where it conflicts with the RULES above, which always win.';

/** Blank and whitespace-only collapse to "no instructions": the block is then omitted entirely. */
export function cleanInstructions(raw: string | null | undefined): string {
  return typeof raw === 'string' ? raw.trim() : '';
}
